// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Gc9t2","main-image":"Header_main-image__AQrQM"};